




import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  name: 'LinkField',
  setup(_, { emit }) {
    const handleClick = () => emit('click');
    return { handleClick };
  },
});
